import { render, staticRenderFns } from "./VirtualResourcePackagePrices.vue?vue&type=template&id=2c45a31e&"
import script from "./VirtualResourcePackagePrices.vue?vue&type=script&lang=js&"
export * from "./VirtualResourcePackagePrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports